import { createClient } from '@slerp/client'
import { GET_USER_BY_EMAIL } from '../LocationQueries'
import isEmpty from 'lodash/isEmpty'

type UserFields =
  | 'confirm_password'
  | 'email'
  | 'firstName'
  | 'lastName'
  | 'password'

type CustomRuleType = (arg: string | boolean) => {
  users: Array<Record<UserFields, string>>
}

const isEmailTaken = async (email: string, merchantId: string) => {
  const apiKey = localStorage.getItem('token') || ''
  const client = createClient(apiKey)

  return await client
    .query({
      query: GET_USER_BY_EMAIL,
      variables: { email, merchantId },
      fetchPolicy: 'no-cache'
    })
    .then((result) => {
      return !isEmpty(result?.data?.getUserByEmail)
    })
    .catch((error: Error) => {
      return false
    })
}

const uniqueEmailRule = (merchantId: string) => ({
  async validator(_: any, value: string) {
    if (!value) return Promise.resolve()
    const isTaken = await isEmailTaken(value, merchantId)

    return isTaken
      ? Promise.reject(
          'This email address is already in use, please use another'
        )
      : Promise.resolve()
  }
})

const confirmPasswordRule = (key: number, getFieldsValue: CustomRuleType) => ({
  async validator(_, value: string) {
    console.log('getFieldsValue(true)', getFieldsValue(true))

    if (!value || getFieldsValue(true)['users'][key]?.password === value) {
      return Promise.resolve()
    }
    return Promise.reject(
      new Error('The passwords you entered do not match. Please try again.')
    )
  }
})

export { uniqueEmailRule, confirmPasswordRule }
